export default {
  expiresSoon: 'Der Zugang zu "{appName}" wird nach dem {expiryDate} deaktiviert.',
};
